import React, { useContext, useEffect } from 'react';
import PageTitle from '../../../Components/PageTitle.js';
import {
  Link
} from '@mui/material';
import LoginForm from './LoginForm.js';
import TwoColumn from '../../../Components/Layout/TwoColumn.js';
import { DrawerContext } from '../../../Context';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../../../helpers/auth.js';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const navigate = useNavigate();
  const { openDrawer, closeDrawer } = useContext(DrawerContext);
  const { t } = useTranslation();

  const handleForgottenPasswordClick = () => {
    openDrawer('forgotten');
  };
  const handleRegisterClick = () => {
    closeDrawer();
    navigate('/register');
  };

  useEffect(() => {
    const loggedIn = isAuthenticated();
    if (loggedIn) {
      navigate('/library');
    }
  }, [navigate]);

  return (
    <>
      <PageTitle title={t('login')} />
      <TwoColumn
        title='login'
        description={
          <>
            <p>
              {t('please-login-to-view-content')}
            </p>
            <p>
              {t('forgotten-your-password')}&nbsp;
              <Link
                style={{ paddingBottom: 3 }}
                component='button'
                variant='body1'
                onClick={handleForgottenPasswordClick}
              >
                {t('reset-it-here')}
              </Link>
            </p>
            <p>
              {t('new-customer')}&nbsp;
              <Link
                style={{ paddingBottom: 3 }}
                component='button'
                variant='body1'
                onClick={handleRegisterClick}
              >
                {t('register-here')}
              </Link>
              <br />
              ({t('or-you-can-register-when-you-buy')})
            </p>
          </>
        }
        form={
          <LoginForm />
        }
      />
    </>
  );
};

export default Login;
